<template>
  <Card dis-hover>
    <div slot="title">
      <slot name="title"></slot>
      <p class="title-item">{{ this.$t('common.this_month') }}</p>
    </div>
    <a href="#" slot="extra">
      <slot name="extra"></slot>
    </a>
    <div class="content">
      <board-one-item
        v-for="(item, index) in StoreList"
        :key="item.id"
        :storeItem="item"
        :storeIndex="index"
        :currentPage="currentPage"
        color="#68DC9A"
      ></board-one-item>
      <Spin size="large" v-if="isLoading" fix></Spin>
      <div
        v-if="!isLoading && (!StoreList || StoreList.length === 0)"
        class="no-data"
      >
        {{ $t('common.no_data') }}
      </div>
    </div>
    <div style="display: flex; justify-content: space-around; margin-top: 10px">
      <Page
        :total="totalPage"
        :page-size="5"
        :current="currentPage"
        size="small"
        @on-change="changPage"
      />
    </div>
  </Card>
</template>
<script>
import boardOneItem from './boardOneItem.vue';
import api from '../../../api/home/index';

export default {
  components: {
    boardOneItem,
  },
  data() {
    return {
      StoreList: [],
      totalPage: null,
      currentPage: 1,
      isLoading: true,
    };
  },
  mounted() {
    this.changPage(1);
  },
  methods: {
    // 分页
    changPage(pageNumber) {
      this.isLoading = true;
      let params = {
        timeRange: 5,
        tagIdList: [],
        sourceTypeList: [],
        showCompare: 0,
        deptNode: [],
        checkerType: 2,
        role: [],
        user: [],
        templateId: [],
        sort: 'desc',
        pageNumber,
        pageSize: 5,
      };

      this.pageShopScore(params).then(() => {
        this.currentPage = pageNumber;
      });
    },
    async pageShopScore(param) {
      let newParam = {
        ...param,
      };
      await api
        .pageShopScore(newParam)
        .then(data => {
          this.StoreList = data.content;
          this.totalPage = data.totalCount;
          this.isLoading = false;
        })
        .catch(e => {
          console.log(e);
          this.isLoading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep {
  .ivu-card-head p {
    width: auto;
  }
}
.title-item {
  padding: 0 5px;
  height: 18px;
  background: #f0f0f0;
  border-radius: 3px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 12px;
  color: #b2b2b2;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  margin-left: 6px;
}

.content {
  height: 200px;
  .rank-index {
    display: inline-block;
    width: 22px;
    height: 22px;
    line-height: 22px;
    border-radius: 6px;
    background: #f0f0f0;
    color: #333333;
    text-align: center;
  }
}
::v-deep {
  .ivu-progress-outer {
    margin-top: 4px;
  }
}
</style>
